import React from "react";

/**
 * Captura erros de renderização da árvore React e exibe fallback amigável,
 * evitando tela branca em produção. Loga no console para debug local e,
 * caso `window.Sentry` esteja disponível (configurável externamente), envia.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, errorInfo);
    if (typeof window !== "undefined" && window.Sentry?.captureException) {
      try {
        window.Sentry.captureException(error, { extra: errorInfo });
      } catch (_) {
        /* ignore */
      }
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          background: "#f5f5f5",
          color: "#333",
        }}
      >
        <h1 style={{ marginBottom: 8 }}>Algo deu errado</h1>
        <p style={{ marginBottom: 24, maxWidth: 480, textAlign: "center" }}>
          A aplicação encontrou um erro inesperado. Tente recarregar a página.
          Se o problema persistir, entre em contato com o suporte.
        </p>
        <button
          type="button"
          onClick={this.handleReload}
          style={{
            padding: "10px 24px",
            background: "#2576d2",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          Recarregar
        </button>
        {process.env.NODE_ENV !== "production" && this.state.error && (
          <pre
            style={{
              marginTop: 24,
              padding: 16,
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: 4,
              maxWidth: "90vw",
              overflow: "auto",
              fontSize: 12,
              color: "#c00",
            }}
          >
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        )}
      </div>
    );
  }
}

export default ErrorBoundary;
